import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { UserItemProps } from 'stream-chat-react';

import { ProfileSuggestionFragment } from 'api';
import { UserAvatar } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(),
  },
}));

const Suggestion: FC<UserItemProps> = ({ entity }) => {
  const classes = useStyles();
  const { name } = entity;

  return (
    <div className={classes.root}>
      <Grid container spacing={1} alignItems="center">
        <Grid item>
          <UserAvatar user={entity as unknown as ProfileSuggestionFragment} size={24} />
        </Grid>
        <Grid item>
          <Typography>{name}</Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default Suggestion;
